import VueRouter from 'vue-router'
import Vue from 'vue'
import storage from '@/utils/localStorage'

Vue.use(VueRouter)

/**
 * Get page meta tags.
 * @param {object} params
 * @param {string} params.pageName - page name to adding to title tag
 * @returns {object}
 */
const getPageMeta = ({ pageName } = {}) => {
  const postfix = 'evbids'
  return {
    title: pageName ? `${pageName} | ${postfix}` : postfix
  }
}

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Profile = () => import('@/views/Profile')
const Settings = () => import('@/views/Settings')
const AuctionManagement = () => import('@/views/AuctionManagement')
const IncomingInventory = () => import('@/views/IncomingInventory')
const ListingOver26 = () => import('@/views/ListingOver26')
const MarketPlaceSoldNA = () => import('@/views/MarketPlaceSoldNA')
const MarketplaceSoldListing = () => import('@/views/MarketplaceSoldListing')
const TeslaVehicleList = () => import('@/views/TeslaVehicleList')
const MarketplaceReconciliation = () => import('@/views/MarketplaceReconciliation')
const MarketplaceListing = () => import('@/views/MarketplaceListing')
const VehicleImport = () => import('@/views/VehicleImport')
const GoogleDrive = () => import('@/views/GoogleDrive')
const CarManager = () => import('@/views/CarManager')
const MarketplaceVehicleManager = () => import('@/views/MarketplaceVehicleManager')
const DraftCarManager = () => import('@/views/DraftCarManager')
const Managers = () => import('@/views/Managers')
const SalesRevenue = () => import('@/views/SalesRevenue')
const Support = () => import('@/views/Support')
const UserManager = () => import('@/views/UserManager')
const AllCars = () => import('@/views/AllCars')
const AllComments = () => import('@/views/AllComments')
const Login = () => import('@/views/Login')
const Blogs = () => import('@/views/Blogs')
const Seo = () => import('@/views/SeoManagement')
const VdpArticle = () => import('@/views/VdpArticle')
const AuctionBanner = () => import('@/views/AuctionBanner')
const ResetPassword = () => import('@/views/reset-password/_token.vue')
const Dealers = () => import('@/views/Dealers')
const TaxCredit = () => import('@/views/TaxCredit')
const Payments = () => import('@/views/Payments')
const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
  fallback: true,
  // "navigationFallback": {  
  //   "rewrite": "index.html",  
  //   "exclude": [".well-known/*", "css/*"]  
  // }
})

function configRoutes () {
  return [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/reset-password/:token',
      name: 'reset-password',
      props: true,
      component: ResetPassword
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: getPageMeta({ pageName: 'Dashboard' })
        }
      ]
    },
    {
      path: '/cars',
      name: 'cars',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'All cars',
          component: AllCars,
          meta: getPageMeta({ pageName: 'Cars' })
        }
      ]
    },
    {
      path: '/comments',
      name: 'comments',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'Comments',
          component: AllComments,
          meta: getPageMeta({ pageName: 'Comments' })
        }
      ]
    },
    {
      path: '/profile',
      name: 'profile',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'Profile',
          component: Profile,
          meta: getPageMeta({ pageName: 'Profile' })
        }
      ]
    },
    {
      path: '/settings',
      name: 'settings',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'Settings',
          component: Settings,
          meta: getPageMeta({ pageName: 'Settings' })
        }
      ]
    },
    // {
    //   path: '/vehicle-import',
    //   name: 'vehicle-import',
    //   component: TheContainer,
    //   children: [
    //     {
    //       path: '/',
    //       name: 'VehicleImportManagement',
    //       component: GoogleDrive,
    //       meta: getPageMeta({ pageName: 'Vehicle Import' })
    //     }
    //   ]
    // },
    {
      path: '/auction-management',
      name: 'auction-management',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'AuctionManagement',
          component: AuctionManagement,
          meta: getPageMeta({ pageName: 'Auctions' })
        }
      ]
    },
    // {
    //   path: '/incoming-inventory',
    //   name: 'incoming-inventory',
    //   component: TheContainer,
    //   children: [
    //     {
    //       path: '/',
    //       name: 'IncomingInventory',
    //       component: IncomingInventory,
    //       meta: getPageMeta({ pageName: 'incoming inventory' })
    //     }
    //   ]
    // },
    {
      path: '/marketplace-listing',
      name: 'marketplace-listing',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'MarketplaceListing',
          component: MarketplaceListing,
          meta: getPageMeta({ pageName: 'Marketplace Listing' })
        }
      ]
    },
    // {
    //   path: '/listing-over-26',
    //   name: 'listing-over-26',
    //   component: TheContainer,
    //   children: [
    //     {
    //       path: '/',
    //       name: 'ListingOver26',
    //       component: ListingOver26,
    //       meta: getPageMeta({ pageName: 'Listing Over 26k' })
    //     }
    //   ]
    // },
    // {
    //   path: '/marketplace-sold',
    //   name: 'marketplace-sold',
    //   component: TheContainer,
    //   children: [
    //     {
    //       path: '/',
    //       name: 'MarketplaceSold',
    //       component: MarketPlaceSoldNA,
    //       meta: getPageMeta({ pageName: 'Marketplace Sold' })
    //     }
    //   ]
    // },
    // {
    //   path: '/marketplace-reconciliation',
    //   name: 'marketplace-reconciliation',
    //   component: TheContainer,
    //   children: [
    //     {
    //       path: '/',
    //       name: 'MarketplaceSold',
    //       component: MarketplaceReconciliation,
    //       meta: getPageMeta({ pageName: 'Marketplace Reconciliation' })
    //     }
    //   ]
    // },
    {
      path: '/draft-vehicle-manager',
      name: 'draft-vehicle-manager',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'draftVehicleManager',
          component: DraftCarManager,
          meta: getPageMeta({ pageName: 'Draft manager' })
        }
      ]
    },
    {
      path: '/vehicle-manager',
      name: 'vehicle-manager',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'vehicleManager',
          component: MarketplaceVehicleManager,
          meta: getPageMeta({ pageName: 'Vehicle manager' })
        }
      ]
    },
    {
      path: '/marketplace-vehicle-sold',
      name: 'Marketplace Vehicle Sold',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'marketplaceVehicleSold',
          component: MarketplaceSoldListing,
          meta: getPageMeta({ pageName: 'Vehicle manager' })
        }
      ]
    },
    {
      path: '/tesla-listing',
      name: 'Tesla Vehicle Listing',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'tesla',
          component: TeslaVehicleList,
          meta: getPageMeta({ pageName: 'Tesla Api' })
        }
      ]
    },
    {
      path: '/managers',
      name: 'managers',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'Managers',
          component: Managers,
          meta: getPageMeta({ pageName: 'Managers' })
        }
      ]
    },
    {
      path: '/sales-revenue',
      name: 'sales-revenue',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'SalesRevenue',
          component: SalesRevenue,
          meta: getPageMeta({ pageName: 'Sales' })
        }
      ]
    },
    {
      path: '/support',
      name: 'support',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'Support',
          component: Support,
          meta: getPageMeta({ pageName: 'Support' })
        }
      ]
    },
    {
      path: '/user-manager',
      name: 'user-manager',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'UserManager',
          component: UserManager,
          meta: getPageMeta({ pageName: 'UserManager' })
        }
      ]
    },
    {
      path: '/consumer-leads',
      name: 'consumer-leads',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'consumer-leads',
          component: TaxCredit,
          meta: getPageMeta({ pageName: 'Consumer Leads' })
        }
      ]
    },
    {
      path: '/dealers',
      name: 'dealers',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'dealers',
          component: Dealers,
          meta: getPageMeta({ pageName: 'Dealers' })
        }
      ]
    },
    {
      path: '/payments',
      name: 'payments',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'payments',
          component: Payments,
          meta: getPageMeta({ pageName: 'Payments' })
        }
      ]
    },
    {
      path: '/tips-&-tricks',
      name: 'Tips & Tricks',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'Tips & Tricks',
          component: Blogs,
          meta: getPageMeta({ pageName: 'Add Tips & Tricks' })
        }
      ]
    },
    {
      path: '/seo',
      name: 'Seo',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'Seo',
          component: Seo,
          meta: getPageMeta({ pageName: 'Seo' })
        }
      ]
    },
    {
      path: '/faq-articles',
      name: 'FAQ Articles',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'FAQ Articles',
          component: VdpArticle,
          meta: getPageMeta({ pageName: 'Add FAQ Articles' })
        }
      ]
    },
    {
      path: '/auction-banner',
      name: 'auction banner',
      component: TheContainer,
      children: [
        {
          path: '/',
          name: 'Auction Banner',
          component: AuctionBanner,
          meta: getPageMeta({ pageName: 'Auction Banner' })
        }
      ]
    },
  ]
}

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || getPageMeta().title
  })
})

router.beforeEach((to, from, next) => {
  const loggedIn = Boolean(storage.getToken())
  if (!loggedIn && to.path !== '/login' && to.name !== 'reset-password') {
    return next('/login')
  }

  next()
})

export default router
